$(document).ready(function () {


    function addProductDiscovery() {
        console.log('addProductDiscovery::: ');
        $.ajax
            ({
                type: 'post',
                url: '/cart/update.js?updates[' + free_product_variant_id + ']=1&updates[' + second_free_product_variant_id + ']=1',
                dataType: 'json',
                success: function (product) {

                    if ($('.cart__page').length > 0) {
                        location.reload();
                    }
                    else {
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail:
                            {
                                product: product
                            }
                        }));
                    }
                },
                error: function (error) {
                    // console.log("Error: "+ error);
                }

            });
    }

    function removeProductDiscovery() {
        console.log('removeProductDiscovery::: ');
        $.ajax
            ({
                type: 'post',
                url: '/cart/update.js?updates[' + free_product_variant_id + ']=0&updates[' + second_free_product_variant_id + ']=0',
                dataType: 'json',
   
                success: function (product) {

                    if ($('.cart__page').length > 0) {
                        location.reload();
                    }
                    else {
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail:
                            {
                                product: product
                            }
                        }));
                    }
                },
                error: function (error) {
                    // console.log("Error: "+ error);
                }

            });
    }

    var total_price = 0;
    function manageDiscoveryGift() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                total_price = cart.total_price;
                if (cart.item_count > 0 ) {
                    // console.log('total_price::: ', total_price);
                    // console.log('gift_threhold_amount::: ', gift_threhold_amount);
                    if ( total_price > 0 )
                    {
                        if (total_price > gift_threhold_amount) {
                            for (let id = 0; id < cart.items.length; id++) {
                                const cart_item = cart.items[id];
                                if (cart_item.variant_id == free_product_variant_id || cart_item.variant_id == second_free_product_variant_id) {
                                    return false;
                                }
                            }

                            if (free_product_variant_id !== '' || second_free_product_variant_id !== '') {
                                addProductDiscovery();
                            }
                        }
                        else {
                            let free_product_variant_available_in_cart = false;
                            let second_free_product_variant_available_in_cart = false;
                            for ( let i=0; i < cart.item_count; i++)
                            {
                                if ( cart.items[i].variant_id == free_product_variant_id )
                                {
                                    free_product_variant_available_in_cart = true;
                                    break;
                                }

                                if ( cart.items[i].variant_id == second_free_product_variant_id )
                                {
                                    second_free_product_variant_available_in_cart = true;
                                    break;
                                }
                            }
                            if (free_product_variant_available_in_cart === true || second_free_product_variant_available_in_cart === true ) {
                                removeProductDiscovery();
                            }
                        }
                    }
                    else
                    {
                        $.ajax
                        ({
                            type: 'post',
                            url: '/cart/clear.js',
                            dataType: 'json',

                            success: function (product) {
                                if ($('.cart__page').length > 0) {
                                    location.reload();
                                }
                                else {
                                    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                                        detail:
                                            {
                                                product: product
                                            }
                                    }));
                                }
                            },
                            error: function (error) {
                                console.log("Error: "+ error);
                            }

                        });
                    }
                }
            })
            .catch(error => {
                // console.error('Error:', error);
            });
    }





    // Target element to observe
    if ($('.cart__page').length > 0) {
        var cartItems = document.querySelector('.custom-subtotal [data-subtotal]');
    }
    else {
        var cartItems = document.querySelector('[data-subtotal]');
    }


    // Function to handle mutations (e.g., node additions)
    let timeout;
    const handleMutations = mutationsList => {
        clearTimeout(timeout);
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList') {
                // Nodes have been added to [data-products]
                setTimeout(() => {
                    manageDiscoveryGift();
                }, 500);

            }
        });
    };

    // Create a MutationObserver instance
    const observer = new MutationObserver(handleMutations);

    // Configuration of the observer (we want to observe childList mutations)
    const config = { childList: true };

    // Start observing the target node for specified mutations
    observer.observe(cartItems, config);
    if ($('.cart__page').length > 0) {
        manageDiscoveryGift();
    }

});